import type { SmsRate } from "./types";

interface RateEntry {
  prefix: string;
  credits: number;
  category: string;
}

export interface RateLookup {
  entries: RateEntry[]; // sorted longest-prefix first
  intlCredits: number;
}

// Mirrors the backend prefix → category resolution for live UI previews.
export function buildRateLookup(rates: SmsRate[]): RateLookup {
  const entries: RateEntry[] = [];
  let intlCredits = 7;
  for (const r of rates) {
    if (r.category === "INTERNATIONAL") {
      intlCredits = r.creditsPerSms;
      continue;
    }
    for (const p of r.prefixes) {
      const clean = p.replace(/\D/g, "");
      if (clean) entries.push({ prefix: clean, credits: r.creditsPerSms, category: r.category });
    }
  }
  entries.sort((a, b) => b.prefix.length - a.prefix.length);
  return { entries, intlCredits };
}

export function categorize(lookup: RateLookup, destination: string): { category: string; creditsPerSms: number } {
  const d = (destination || "").replace(/\D/g, "");
  for (const e of lookup.entries) {
    if (d.startsWith(e.prefix)) return { category: e.category, creditsPerSms: e.credits };
  }
  return { category: "INTERNATIONAL", creditsPerSms: lookup.intlCredits };
}
